import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import Skeleton from '../components/Skeleton';
import avatarMale from '../assets/images/avatars/avatar_male.png';
import avatarFemale from '../assets/images/avatars/avatar_female.png';
import avatarDoctorMale from '../assets/images/avatars/avatar_doctor_male.png';
import avatarDoctorFemale from '../assets/images/avatars/avatar_doctor_female.png';
import { FaHouseChimney } from 'react-icons/fa6';
import { FaCog } from 'react-icons/fa';
import { logout } from '../controllers/AuthController';
import { useAuth } from '../context/AuthContext';

const ProfileDropdown = ({ t }) => {
    const { auth, loading } = useAuth();
    const location = useLocation();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    
    const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
    
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            };
        };
        
        document.addEventListener('mousedown', handleClickOutside);
        
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    
    const handleLogout = async () => {
        try {
            await logout();
            setIsDropdownOpen(false);
            window.location.reload();
        } catch (error) {
            setIsDropdownOpen(false);
            toast.error(error);
        };
    };
    
    if (loading) {
        return (
            <div className='relative'>
                <Skeleton className='flex h-10 w-10 rounded-full' />
            </div>
        );
    };
    
    return (
        <div className='relative' ref={dropdownRef}>
            <button
                className={`
                    flex h-10 w-10 p-1 rounded-full bg-gradient-to-r from-primary to-secondary cursor-pointer
                    hover:outline-none hover:via-primary hover:to-secondary
                    focus:outline-none focus:to-primary
                `}
                type='button'
                onClick={toggleDropdown}
            >
                <div className='h-full w-full rounded-full bg-white shadow-[inset_0_4px_4px_rgba(0,0,0,0.2)] overflow-hidden'>
                    <img
                        className='h-full w-full mt-1 rounded-full'
                        src={
                            auth?.role.name.toLowerCase().includes('admin')
                            ? auth?.gender === 'Female' ? avatarFemale : avatarMale
                            : auth?.gender === 'Female' ? avatarDoctorFemale : avatarDoctorMale
                        }
                        alt=''
                    />
                </div>
            </button>
            
            {/* Dropdown Menu */}
            {isDropdownOpen && (
                <div className='absolute mt-2 w-44 right-0 rounded-lg bg-white divide-y divide-platinum shadow-md'>
                    <div className='p-4 text-xs md:text-sm space-y-0.5'>
                        <div className='text-black font-semibold'>{auth?.name || 'null'}</div>
                        <div className='text-grayX11'>{auth?.role.name || 'null'}</div>
                    </div>
                    <div className='p-2'>
                        <ul className='text-xs md:text-sm font-medium text-black space-y-1'>
                            <li>
                                <a
                                    className={`
                                        flex p-2 items-center rounded space-x-2
                                        ${location.pathname === '/dashboard'
                                            ? 'text-white bg-gradient-to-r from-primary to-secondary hover:outline-none hover:via-primary hover:to-secondary focus:outline-none focus:to-primary'
                                            : 'hover:outline-none hover:bg-platinum focus:outline-none focus:bg-grayX11'
                                        }
                                    `}
                                    href={location.pathname === '/dashboard' ? undefined : '/dashboard'}
                                    aria-disabled={location.pathname === '/dashboard'}
                                >
                                    <FaHouseChimney className='h-full' />
                                    <span>{t('menu.dashboard')}</span>
                                </a>
                            </li>
                            <li>
                                <a
                                    className={`
                                        flex p-2 items-center rounded space-x-2
                                        ${location.pathname === '/change-password'
                                            ? 'text-white bg-gradient-to-r from-primary to-secondary hover:outline-none hover:via-primary hover:to-secondary focus:outline-none focus:to-primary'
                                            : 'hover:outline-none hover:bg-platinum focus:outline-none focus:bg-grayX11'
                                        }
                                    `}
                                    href={location.pathname === '/change-password' ? undefined : '/change-password'}
                                    aria-disabled={location.pathname === '/change-password'}
                                >
                                    <FaCog />
                                    <span>{t('menu.changePassword')}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className='p-2'>
                        <button
                            className={`
                                flex p-2 w-full items-center justify-center rounded text-xs md:text-sm text-errorMessage font-semibold
                                hover:outline-none hover:bg-errorAccentPrimary focus:outline-none focus:bg-errorAccentSecondary
                            `}
                            onClick={handleLogout}
                        >
                            {t('menu.logout')}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProfileDropdown;
